module.exports = __webpack_public_path__ + "static/media/design-img-1.d53f7090.jpg";